function _typeof(o) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) {
    return typeof o;
  } : function (o) {
    return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
  }, _typeof(o);
}
function _createForOfIteratorHelper(r, e) {
  var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
  if (!t) {
    if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) {
      t && (r = t);
      var _n = 0,
        F = function F() {};
      return {
        s: F,
        n: function n() {
          return _n >= r.length ? {
            done: !0
          } : {
            done: !1,
            value: r[_n++]
          };
        },
        e: function e(r) {
          throw r;
        },
        f: F
      };
    }
    throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
  }
  var o,
    a = !0,
    u = !1;
  return {
    s: function s() {
      t = t.call(r);
    },
    n: function n() {
      var r = t.next();
      return a = r.done, r;
    },
    e: function e(r) {
      u = !0, o = r;
    },
    f: function f() {
      try {
        a || null == t["return"] || t["return"]();
      } finally {
        if (u) throw o;
      }
    }
  };
}
function _unsupportedIterableToArray(r, a) {
  if (r) {
    if ("string" == typeof r) return _arrayLikeToArray(r, a);
    var t = {}.toString.call(r).slice(8, -1);
    return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0;
  }
}
function _arrayLikeToArray(r, a) {
  (null == a || a > r.length) && (a = r.length);
  for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e];
  return n;
}
function _regenerator() {
  /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */var e,
    t,
    r = "function" == typeof Symbol ? Symbol : {},
    n = r.iterator || "@@iterator",
    o = r.toStringTag || "@@toStringTag";
  function i(r, n, o, i) {
    var c = n && n.prototype instanceof Generator ? n : Generator,
      u = Object.create(c.prototype);
    return _regeneratorDefine2(u, "_invoke", function (r, n, o) {
      var i,
        c,
        u,
        f = 0,
        p = o || [],
        y = !1,
        G = {
          p: 0,
          n: 0,
          v: e,
          a: d,
          f: d.bind(e, 4),
          d: function d(t, r) {
            return i = t, c = 0, u = e, G.n = r, a;
          }
        };
      function d(r, n) {
        for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) {
          var o,
            i = p[t],
            d = G.p,
            l = i[2];
          r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0));
        }
        if (o || r > 1) return a;
        throw y = !0, n;
      }
      return function (o, p, l) {
        if (f > 1) throw TypeError("Generator is already running");
        for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) {
          i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u);
          try {
            if (f = 2, i) {
              if (c || (o = "next"), t = i[o]) {
                if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object");
                if (!t.done) return t;
                u = t.value, c < 2 && (c = 0);
              } else 1 === c && (t = i["return"]) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1);
              i = e;
            } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break;
          } catch (t) {
            i = e, c = 1, u = t;
          } finally {
            f = 1;
          }
        }
        return {
          value: t,
          done: y
        };
      };
    }(r, o, i), !0), u;
  }
  var a = {};
  function Generator() {}
  function GeneratorFunction() {}
  function GeneratorFunctionPrototype() {}
  t = Object.getPrototypeOf;
  var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () {
      return this;
    }), t),
    u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c);
  function f(e) {
    return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e;
  }
  return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () {
    return this;
  }), _regeneratorDefine2(u, "toString", function () {
    return "[object Generator]";
  }), (_regenerator = function _regenerator() {
    return {
      w: i,
      m: f
    };
  })();
}
function _regeneratorDefine2(e, r, n, t) {
  var i = Object.defineProperty;
  try {
    i({}, "", {});
  } catch (e) {
    i = 0;
  }
  _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) {
    function o(r, n) {
      _regeneratorDefine2(e, r, function (e) {
        return this._invoke(r, n, e);
      });
    }
    r ? i ? i(e, r, {
      value: n,
      enumerable: !t,
      configurable: !t,
      writable: !t
    }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2));
  }, _regeneratorDefine2(e, r, n, t);
}
function asyncGeneratorStep(n, t, e, r, o, a, c) {
  try {
    var i = n[a](c),
      u = i.value;
  } catch (n) {
    return void e(n);
  }
  i.done ? t(u) : Promise.resolve(u).then(r, o);
}
function _asyncToGenerator(n) {
  return function () {
    var t = this,
      e = arguments;
    return new Promise(function (r, o) {
      var a = n.apply(t, e);
      function _next(n) {
        asyncGeneratorStep(a, r, o, _next, _throw, "next", n);
      }
      function _throw(n) {
        asyncGeneratorStep(a, r, o, _next, _throw, "throw", n);
      }
      _next(void 0);
    });
  };
}
function _classCallCheck(a, n) {
  if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function");
}
function _defineProperties(e, r) {
  for (var t = 0; t < r.length; t++) {
    var o = r[t];
    o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o);
  }
}
function _createClass(e, r, t) {
  return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", {
    writable: !1
  }), e;
}
function _toPropertyKey(t) {
  var i = _toPrimitive(t, "string");
  return "symbol" == _typeof(i) ? i : i + "";
}
function _toPrimitive(t, r) {
  if ("object" != _typeof(t) || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != _typeof(i)) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r ? String : Number)(t);
}
var SaitoOverlay = require('../../../../../lib/saito/ui/saito-overlay/saito-overlay');
var LoungeOverlayTemplate = require('./lounge.template');
var jsonTree = require('json-tree-viewer');

/*
  General Interface for the Overlay that comes up when you click on a (game) "invite".
  There are several circumstances that affect what a user can do with the overlay, but because
  so much of the UI is identical it is better to have it all in one file instead of multiple
  files with the logic spread out across all the places where you might need to trigger the overlay.

  The basic purpose is to display the game details (results of game-selector/game-wizard) and allow a player to join/cance
*/
var LoungeOverlay = /*#__PURE__*/function () {
  function LoungeOverlay(app, mod, invite) {
    var _this = this;
    _classCallCheck(this, LoungeOverlay);
    this.app = app;
    this.mod = mod;
    this.invite = invite;
    this.game_id = null;
    this.overlay = new SaitoOverlay(app, mod, false, true); //No close button, auto-delete overlay

    app.connection.on('relay-is-online', /*#__PURE__*/function () {
      var _ref = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee(pkey) {
        return _regenerator().w(function (_context) {
          while (1) switch (_context.n) {
            case 0:
              if (_this.invite && pkey == _this.invite.originator) {
                if (document.getElementById("invite-user-".concat(pkey))) {
                  document.getElementById("invite-user-".concat(pkey)).classList.add('online');
                }
              }
            case 1:
              return _context.a(2);
          }
        }, _callee);
      }));
      return function (_x) {
        return _ref.apply(this, arguments);
      };
    }());
    app.connection.on('relay-is-busy', /*#__PURE__*/function () {
      var _ref2 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2(pkey) {
        return _regenerator().w(function (_context2) {
          while (1) switch (_context2.n) {
            case 0:
              if (_this.invite && pkey == _this.invite.originator) {
                if (document.getElementById("invite-user-".concat(pkey))) {
                  document.getElementById("invite-user-".concat(pkey)).classList.add('online');
                  document.getElementById("invite-user-".concat(pkey)).classList.add('busy');
                }
              }
            case 1:
              return _context2.a(2);
          }
        }, _callee2);
      }));
      return function (_x2) {
        return _ref2.apply(this, arguments);
      };
    }());
    app.connection.on('arcade-close-game', function (game_id) {
      if (game_id == (_this === null || _this === void 0 ? void 0 : _this.game_id)) {
        _this.overlay.close();
        if (_this.mod.browser_active && _this.mod.ui) {
          _this.mod.ui.render();
        }
      }
    });
  }
  return _createClass(LoungeOverlay, [{
    key: "render",
    value: function render() {
      if (this.game_id != null && this.invite == null) {
        this._renderGameIdMode();
        return;
      }
      var game_mod = this.app.modules.returnModuleBySlug(this.invite.game_slug);
      if (this.mod.sudo) {
        this.overlay.show("<div class=\"arcade-lounge debug_overlay\"><button class=\"saito-button-primary\" id=\"clear-invite\">Delete</button></div>");
        if (!this.mod.styles.includes('/saito/lib/jsonTree/jsonTree.css')) {
          this.mod.styles.push('/saito/lib/jsonTree/jsonTree.css');
          this.mod.attachStyleSheets();
        }
        var el = document.querySelector('.arcade-lounge');
        try {
          var optjson = JSON.parse(JSON.stringify(this.invite, function (key, value) {
            return key == 'game_mod' ? 'game_mod' : value;
          }));
          var tree = jsonTree.create(optjson, el);
        } catch (err) {
          console.error('ARCADE: [joinGame] error creating jsonTree: ', err);
        }
      } else {
        this.overlay.show(LoungeOverlayTemplate(this.app, this.mod, this.invite));
      }
      this.overlay.setBackground(game_mod.respondTo('arcade-games').image);
      this.attachEvents();
      this.app.connection.emit('add-league-identifier-to-dom');
    }
  }, {
    key: "_resolveGameIdContext",
    value: function _resolveGameIdContext() {
      var _game$tx, _game_mod, _game_mod$returnSlug, _game_mod2, _game_mod2$respondTo, _game_mod$returnName, _game_mod3;
      var game = this.mod.returnGame(this.game_id);
      var state = game === null || game === void 0 ? void 0 : game.state;
      var txGame = game === null || game === void 0 || (_game$tx = game.tx) === null || _game$tx === void 0 || (_game$tx = _game$tx.msg) === null || _game$tx === void 0 ? void 0 : _game$tx.game;
      var stateModule = state === null || state === void 0 ? void 0 : state.module;
      var game_mod = this.app.modules.returnModule(txGame) || this.app.modules.returnModuleBySlug(stateModule || txGame || 'arcade') || this.app.modules.returnModule(stateModule);
      if (!game_mod && this.observer_game_module_slug) {
        game_mod = this.app.modules.returnModuleBySlug(this.observer_game_module_slug);
      }
      var slug = ((_game_mod = game_mod) === null || _game_mod === void 0 || (_game_mod$returnSlug = _game_mod.returnSlug) === null || _game_mod$returnSlug === void 0 ? void 0 : _game_mod$returnSlug.call(_game_mod)) || stateModule || txGame || this.observer_game_module_slug || 'arcade';
      var image = ((_game_mod2 = game_mod) === null || _game_mod2 === void 0 || (_game_mod2$respondTo = _game_mod2.respondTo) === null || _game_mod2$respondTo === void 0 || (_game_mod2$respondTo = _game_mod2$respondTo.call(_game_mod2, 'arcade-games')) === null || _game_mod2$respondTo === void 0 ? void 0 : _game_mod2$respondTo.image) || '';
      var gameName = game_mod && (((_game_mod$returnName = (_game_mod3 = game_mod).returnName) === null || _game_mod$returnName === void 0 ? void 0 : _game_mod$returnName.call(_game_mod3)) || game_mod.name) || txGame || slug;
      return {
        game: game,
        state: state,
        game_mod: game_mod,
        slug: slug,
        image: image,
        gameName: gameName
      };
    }
  }, {
    key: "_getLoungeRoot",
    value: function _getLoungeRoot() {
      var _this$overlay;
      if (!((_this$overlay = this.overlay) !== null && _this$overlay !== void 0 && _this$overlay.visible)) return null;
      var el = document.getElementById("saito-overlay".concat(this.overlay.ordinal));
      if (!el || el.style.display === 'none') return null;
      return el.querySelector('.arcade-lounge');
    }

    /**
     * Transition an open initializing lounge to the ready state without re-showing the overlay.
     */
  }, {
    key: "showGameReadyState",
    value: function showGameReadyState() {
      if (this.game_id == null || this.invite != null) return false;
      var root = this._getLoungeRoot();
      if (!root) return false;
      var _this$_resolveGameIdC = this._resolveGameIdContext(),
        game = _this$_resolveGameIdC.game,
        state = _this$_resolveGameIdC.state,
        game_mod = _this$_resolveGameIdC.game_mod,
        image = _this$_resolveGameIdC.image,
        gameName = _this$_resolveGameIdC.gameName;
      var stateLabel = 'Game Ready';
      var _this$_buildGameSecti = this._buildGameSections(game, state, game_mod),
        detailsHtml = _this$_buildGameSecti.detailsHtml,
        playersHtml = _this$_buildGameSecti.playersHtml,
        playerCount = _this$_buildGameSecti.playerCount;
      var controls = ['<div id="arcade-game-controls-start-game" class="saito-button-primary">Start Game</div>', '<div id="arcade-game-controls-close-game" class="saito-button-secondary">Hide</div>'];
      var descEl = root.querySelector('.arcade-lounge-header-desc');
      var detailsEl = root.querySelector('.arcade-lounge-details .saito-table-body');
      var playersEl = root.querySelector('.arcade-lounge-section');
      var controlsEl = root.querySelector('.arcade-lounge-controls');
      var titleEl = root.querySelector('.arcade-lounge-header-title');
      var heroEl = root.querySelector('.arcade-lounge-hero');
      if (!descEl || !detailsEl || !playersEl || !controlsEl) return false;
      if (titleEl) titleEl.textContent = gameName;
      if (heroEl && image) heroEl.src = image;
      descEl.classList.remove('arcade-lounge-header-desc--loading');
      descEl.textContent = stateLabel;
      detailsEl.innerHTML = detailsHtml;
      playersEl.innerHTML = playersHtml;
      controlsEl.className = this._gameControlClasses(playerCount, controls.length);
      controlsEl.innerHTML = controls.join('');
      this.attachEvents();
      this.app.connection.emit('add-league-identifier-to-dom');
      return true;
    }
  }, {
    key: "_renderGameIdMode",
    value: function _renderGameIdMode() {
      var _this$_resolveGameIdC2 = this._resolveGameIdContext(),
        game = _this$_resolveGameIdC2.game,
        state = _this$_resolveGameIdC2.state,
        game_mod = _this$_resolveGameIdC2.game_mod,
        image = _this$_resolveGameIdC2.image,
        gameName = _this$_resolveGameIdC2.gameName;
      var derivedState;
      if (state && state.initializing === 1) {
        derivedState = 'INITIALIZING';
      } else if (state && state.initializing === 0 && !state.over) {
        derivedState = 'READY';
      } else if (state && state.over === 1) {
        derivedState = 'COMPLETED';
      } else {
        derivedState = 'INITIALIZING';
      }
      var stateLabel, stateIndicator, playerMessage, controls;
      var _this$_buildGameSecti2 = this._buildGameSections(game, state, game_mod),
        detailsHtml = _this$_buildGameSecti2.detailsHtml,
        playersHtml = _this$_buildGameSecti2.playersHtml,
        playerCount = _this$_buildGameSecti2.playerCount;

      //
      // No local metadata for this game_id – show observer overlay.
      // If archive has game data: enable Watch Game. Otherwise: show message and disable button.
      //
      if (!game) {
        stateLabel = 'Observer Mode';
        // Observer/spectate is disabled pending the GameObserver rebuild -- show a
        // message instead of a (broken) Watch Game button. Restore the button
        // when the observer is functional again.
        detailsHtml = '';
        playersHtml = '';
        playerCount = 0;
        playerMessage = '<div class="arcade-lounge-message arcade-lounge-message-game-id">This server does not have viewable game data for this match.</div>';
        controls = [];
      } else if (derivedState === 'INITIALIZING') {
        stateLabel = 'Initializing Game';
        stateIndicator = '<span id="game-loader-spinner" class="arcade-lounge-loader game-loader-spinner" aria-hidden="true"></span>';
        controls = [];
      } else if (derivedState === 'READY') {
        stateLabel = 'Game Ready';
        controls = ['<div id="arcade-game-controls-start-game" class="saito-button-primary">Start Game</div>', '<div id="arcade-game-controls-close-game" class="saito-button-secondary">Hide</div>'];
      } else {
        stateLabel = 'Game completed';
        controls = ['<div id="arcade-game-controls-continue-game" class="saito-button-primary">View game</div>'];
      }
      var safeImage = this.app.browser.escapeHTML(image);
      var safeGameName = this.app.browser.escapeHTML(gameName);
      var safeStateLabel = this.app.browser.escapeHTML(stateLabel);
      var html = "\n      <div class=\"arcade-lounge arcade-lounge--game arcade-lounge--four-sector saito-overlay-panel\">\n        <div class=\"arcade-lounge-art\">\n          <img class=\"arcade-lounge-hero\" src=\"".concat(safeImage, "\" alt=\"\">\n        </div>\n\n        <section class=\"arcade-lounge-info\" aria-labelledby=\"arcade-lounge-title\">\n          <h1 id=\"arcade-lounge-title\" class=\"arcade-lounge-header-title\">").concat(safeGameName, "</h1>\n          <h3 class=\"arcade-lounge-header-desc").concat(stateIndicator ? ' arcade-lounge-header-desc--loading' : '', "\">\n            <span>").concat(safeStateLabel, "</span>\n            ").concat(stateIndicator || '', "\n          </h3>\n          <div class=\"arcade-lounge-details saito-table\">\n            <div class=\"saito-table-body\">").concat(detailsHtml, "</div>\n          </div>\n        </section>\n\n        <section class=\"arcade-lounge-section hide-scrollbar\" aria-label=\"Players\">\n          ").concat(playersHtml).concat(playerMessage || '', "\n        </section>\n\n        <div class=\"arcade-lounge-chat\"></div>\n        <div class=\"").concat(this._gameControlClasses(playerCount, controls.length), "\">").concat(controls.join(''), "</div>\n      </div>");
      this.overlay.show(html);
      this.overlay.setBackground(image);
      this.attachEvents();
      this.app.connection.emit('add-league-identifier-to-dom');
    }
  }, {
    key: "_gamePlayerRows",
    value: function _gamePlayerRows(playerCount) {
      return Math.min(3, Math.max(1, Math.ceil(playerCount / 2)));
    }
  }, {
    key: "_gameControlClasses",
    value: function _gameControlClasses(playerCount, controlCount) {
      return "arcade-lounge-controls arcade-lounge-controls--standard arcade-lounge-controls--".concat(this._gamePlayerRows(playerCount), "-rows arcade-lounge-controls--").concat(controlCount, "-actions");
    }
  }, {
    key: "_buildGameSections",
    value: function _buildGameSections(record, state, game_mod) {
      var _record$tx,
        _record$tx2,
        _record$tx3,
        _record$tx4,
        _this2 = this;
      var players = (state === null || state === void 0 ? void 0 : state.players) || (record === null || record === void 0 || (_record$tx = record.tx) === null || _record$tx === void 0 || (_record$tx = _record$tx.msg) === null || _record$tx === void 0 ? void 0 : _record$tx.players) || [];
      var options = (state === null || state === void 0 ? void 0 : state.options) || (record === null || record === void 0 || (_record$tx2 = record.tx) === null || _record$tx2 === void 0 || (_record$tx2 = _record$tx2.msg) === null || _record$tx2 === void 0 ? void 0 : _record$tx2.options) || {};
      var tentative = (record === null || record === void 0 || (_record$tx3 = record.tx) === null || _record$tx3 === void 0 || (_record$tx3 = _record$tx3.msg) === null || _record$tx3 === void 0 ? void 0 : _record$tx3.tentative) || {
        join: [],
        leave: []
      };
      var leaving = new Set(tentative.leave || []);

      //
      // cashouts come from the arcade invite record (populated by the leave tx
      // as "<n> CHIPS" strings), NOT the in-game boolean map on state.options
      //
      var eliminated = (record === null || record === void 0 || (_record$tx4 = record.tx) === null || _record$tx4 === void 0 || (_record$tx4 = _record$tx4.msg) === null || _record$tx4 === void 0 || (_record$tx4 = _record$tx4.options) === null || _record$tx4 === void 0 ? void 0 : _record$tx4.eliminated) || {};
      var optsHtml = '';
      if (game_mod && typeof game_mod.returnShortGameOptionsArray === 'function') {
        var sgoa = game_mod.returnShortGameOptionsArray(options);
        for (var key in sgoa) {
          if (sgoa[key] != null) {
            optsHtml += "<div class=\"saito-table-row\"><div class=\"arcade-lounge-key\">".concat(String(key).replace(/_/g, ' '), "</div><div class=\"arcade-lounge-value\">").concat(sgoa[key], "</div></div>");
          }
        }
      }
      var playerRow = function playerRow(pkey) {
        var extraClass = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
        var note = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '';
        var safeKey = _this2.app.browser.escapeHTML(pkey);
        return "\n        <div class=\"arcade-lounge-playerbox saito-table-row ".concat(extraClass, "\" id=\"invite-user-").concat(safeKey, "\">\n          <div class=\"saito-identicon-box\">\n            <img class=\"saito-identicon\" src=\"").concat(_this2.app.keychain.returnIdenticon(pkey), "\">\n            ").concat(note ? '' : '<div class="online-status-indicator"></div>', "\n          </div>\n          <div class=\"arcade-lounge-player-identity\">\n            ").concat(_this2.app.browser.returnAddressHTML(pkey), "\n            <div class=\"arcade-lounge-player-key\" title=\"").concat(safeKey, "\">").concat(safeKey, "</div>\n            ").concat(note ? "<div class=\"arcade-lounge-player-note\">".concat(note, "</div>") : '', "\n          </div>\n        </div>");
      };
      var playersHtml = '';
      for (var i = 0; i < players.length; i++) {
        var pkey = players[i];
        var isLeaving = leaving.has(pkey);
        playersHtml += playerRow(pkey, isLeaving ? 'leaving' : '', isLeaving ? 'leaving next hand' : '');
      }
      // tentative joiners not yet seated
      var _iterator = _createForOfIteratorHelper(tentative.join || []),
        _step;
      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var _pkey2 = _step.value;
          if (!players.includes(_pkey2)) {
            playersHtml += playerRow(_pkey2, 'pending', 'joining next hand');
          }
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }
      var eliminatedHtml = '';
      for (var _pkey in eliminated) {
        if (players.includes(_pkey)) {
          continue;
        }
        var amt = typeof eliminated[_pkey] === 'string' ? eliminated[_pkey] : '';
        eliminatedHtml += playerRow(_pkey, 'eliminated', amt ? "cashed out ".concat(amt) : 'left the table');
      }
      var eliminatedSection = eliminatedHtml ? "<div class=\"arcade-lounge-eliminated-label\">Cashed out</div>\n\t    <div class=\"arcade-lounge-players arcade-lounge-eliminated\">".concat(eliminatedHtml, "\n\t    </div>") : '';
      var playerCount = players.length + (tentative.join || []).filter(function (pkey) {
        return !players.includes(pkey);
      }).length;
      return {
        detailsHtml: optsHtml,
        playersHtml: "<div class=\"arcade-lounge-players\">".concat(playersHtml, "</div>").concat(eliminatedSection),
        playerCount: playerCount
      };
    }

    //
    // If the invite carries a crypto stake, route through the stake-consent
    // overlay and run accept_callback (with the confirmed stake input) on
    // approval; otherwise run it directly.
    //
  }, {
    key: "confirmStakeThen",
    value: function confirmStakeThen(game_mod, accept_callback) {
      var _opts$stake;
      var opts = this.invite.options;
      if (opts.crypto && (parseFloat(opts.stake) > 0 || parseFloat((_opts$stake = opts.stake) === null || _opts$stake === void 0 ? void 0 : _opts$stake.min) >= 0)) {
        this.app.connection.emit('accept-game-stake', {
          game_mod: game_mod,
          ticker: opts.crypto,
          stake: opts.stake,
          accept_callback: accept_callback
        });
      } else {
        accept_callback();
      }
    }
  }, {
    key: "attachEvents",
    value: function attachEvents() {
      var _this3 = this;
      var detailsToggle = document.getElementById('arcade-lounge-details-toggle');
      if (detailsToggle) {
        var details = document.getElementById(detailsToggle.getAttribute('aria-controls'));
        detailsToggle.onclick = function () {
          if (!details) return;
          var expanded = detailsToggle.getAttribute('aria-expanded') === 'true';
          details.hidden = expanded;
          detailsToggle.setAttribute('aria-expanded', String(!expanded));
          detailsToggle.textContent = expanded ? 'details' : 'hide details';
        };
      }
      var startBtn = document.getElementById('arcade-game-controls-start-game');
      if (startBtn && this.game_id != null) {
        startBtn.onclick = function (e) {
          var _game$tx2, _game$state, _mod$returnSlug, _this3$app$modules$re;
          var game = _this3.mod.returnGame(_this3.game_id);
          var gameName = (game === null || game === void 0 || (_game$tx2 = game.tx) === null || _game$tx2 === void 0 || (_game$tx2 = _game$tx2.msg) === null || _game$tx2 === void 0 ? void 0 : _game$tx2.game) || (game === null || game === void 0 || (_game$state = game.state) === null || _game$state === void 0 ? void 0 : _game$state.module);
          var mod = gameName ? _this3.app.modules.returnModule(gameName) : null;
          var slug = (mod === null || mod === void 0 || (_mod$returnSlug = mod.returnSlug) === null || _mod$returnSlug === void 0 ? void 0 : _mod$returnSlug.call(mod)) || (mod === null || mod === void 0 ? void 0 : mod.slug) || gameName || 'arcade';
          var am = ((_this3$app$modules$re = _this3.app.modules.returnActiveModule()) === null || _this3$app$modules$re === void 0 ? void 0 : _this3$app$modules$re.returnName()) || 'Arcade';
          _this3.app.options.homeModule = am;
          _this3.app.storage.saveOptions();
          navigateWindow("/".concat(slug), 200);
        };
      }
      var joinGameButton = document.getElementById('arcade-game-controls-join-game');
      if (joinGameButton) {
        //This is a joinable game
        this.app.connection.emit('relay-send-message', {
          recipient: [this.invite.originator],
          request: 'ping',
          data: {}
        });
        joinGameButton.onclick = /*#__PURE__*/function () {
          var _ref3 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee3(e) {
            var _this3$invite$options;
            var open_invites, c, _iterator2, _step2, game_id, game_mod, _t;
            return _regenerator().w(function (_context3) {
              while (1) switch (_context3.p = _context3.n) {
                case 0:
                  open_invites = _this3.mod.returnOpenInvites();
                  if (!(open_invites.length > 0)) {
                    _context3.n = 2;
                    break;
                  }
                  _context3.n = 1;
                  return sconfirm('You have an open invite. Would you like to close it to join this game?');
                case 1:
                  c = _context3.v;
                  if (c) {
                    _iterator2 = _createForOfIteratorHelper(open_invites);
                    try {
                      for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
                        game_id = _step2.value;
                        _this3.mod.sendCancelTransaction(game_id);
                      }
                    } catch (err) {
                      _iterator2.e(err);
                    } finally {
                      _iterator2.f();
                    }
                  }
                case 2:
                  _this3.overlay.remove();
                  if (!(_this3.invite.options.crypto && (parseFloat(_this3.invite.options.stake) > 0 || parseFloat((_this3$invite$options = _this3.invite.options.stake) === null || _this3$invite$options === void 0 ? void 0 : _this3$invite$options.min) >= 0))) {
                    _context3.n = 6;
                    break;
                  }
                  _context3.p = 3;
                  game_mod = _this3.app.modules.returnModuleBySlug(_this3.invite.game_slug);
                  _this3.app.connection.emit('accept-game-stake', {
                    game_mod: game_mod,
                    ticker: _this3.invite.options.crypto,
                    stake: _this3.invite.options.stake,
                    accept_callback: function accept_callback() {
                      var input = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
                      var update_options = input !== null && _typeof(_this3.invite.options.stake) == 'object' ? 'stake' : '';
                      if (update_options) {
                        _this3.invite.options.stake[_this3.mod.publicKey] = input;
                      }
                      _this3.mod.sendJoinTransaction(_this3.invite, update_options);
                    }
                  });
                  _context3.n = 5;
                  break;
                case 4:
                  _context3.p = 4;
                  _t = _context3.v;
                  console.error('ARCADE [joinGame] ERROR checking crypto: ', _t);
                  return _context3.a(2, false);
                case 5:
                  _context3.n = 7;
                  break;
                case 6:
                  _this3.mod.sendJoinTransaction(_this3.invite);
                case 7:
                  return _context3.a(2);
              }
            }, _callee3, null, [[3, 4]]);
          }));
          return function (_x3) {
            return _ref3.apply(this, arguments);
          };
        }();
      }
      if (document.getElementById('arcade-game-controls-continue-game')) {
        document.getElementById('arcade-game-controls-continue-game').onclick = function (e) {
          var slug, gameId, name;
          if (_this3.invite) {
            var _this3$invite$game_mo;
            slug = _this3.invite.game_slug;
            gameId = _this3.invite.game_id;
            name = (_this3$invite$game_mo = _this3.invite.game_mod) === null || _this3$invite$game_mo === void 0 ? void 0 : _this3$invite$game_mo.name;
          } else if (_this3.game_id != null) {
            var _game$tx3, _game$state2, _mod$returnSlug2, _mod$returnName;
            var game = _this3.mod.returnGame(_this3.game_id);
            var gameName = (game === null || game === void 0 || (_game$tx3 = game.tx) === null || _game$tx3 === void 0 || (_game$tx3 = _game$tx3.msg) === null || _game$tx3 === void 0 ? void 0 : _game$tx3.game) || (game === null || game === void 0 || (_game$state2 = game.state) === null || _game$state2 === void 0 ? void 0 : _game$state2.module);
            var mod = gameName ? _this3.app.modules.returnModule(gameName) : null;
            slug = (mod === null || mod === void 0 || (_mod$returnSlug2 = mod.returnSlug) === null || _mod$returnSlug2 === void 0 ? void 0 : _mod$returnSlug2.call(mod)) || (mod === null || mod === void 0 ? void 0 : mod.slug) || gameName || 'arcade';
            gameId = _this3.game_id;
            name = (mod === null || mod === void 0 || (_mod$returnName = mod.returnName) === null || _mod$returnName === void 0 ? void 0 : _mod$returnName.call(mod)) || (mod === null || mod === void 0 ? void 0 : mod.name);
          }
          if (slug != null && gameId != null) {
            navigateWindow("/".concat(slug, "/#gid=").concat(encodeURIComponent(gameId)));
          }
        };
      }
      if (document.getElementById('arcade-game-controls-close-game')) {
        document.getElementById('arcade-game-controls-close-game').onclick = /*#__PURE__*/function () {
          var _ref4 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee4(e) {
            var c, _this3$invite$game_mo2;
            return _regenerator().w(function (_context4) {
              while (1) switch (_context4.n) {
                case 0:
                  if (!_this3.invite) {
                    _context4.n = 2;
                    break;
                  }
                  _this3.overlay.remove();
                  _context4.n = 1;
                  return sconfirm('Are you sure you want to end the game?');
                case 1:
                  c = _context4.v;
                  if (c) {
                    _this3.app.connection.emit('arcade-stop-game', (_this3$invite$game_mo2 = _this3.invite.game_mod) === null || _this3$invite$game_mo2 === void 0 ? void 0 : _this3$invite$game_mo2.name, _this3.invite.game_id, 'cancellation');
                  }
                  _context4.n = 3;
                  break;
                case 2:
                  if (_this3.game_id != null) {
                    _this3.overlay.remove();
                  }
                case 3:
                  return _context4.a(2);
              }
            }, _callee4);
          }));
          return function (_x4) {
            return _ref4.apply(this, arguments);
          };
        }();
      }

      //
      // This is a little complicated because an initialized game will persist in the
      // app.options and keep getting added back to the arcade list because it didn't
      // reach a gameover. So, we send a game over request through the game, but if the opponent
      // isn't online it doesn't process, so we need an additional fallback just to make
      // sure we aren't annoyed by being unable to close a game.
      // Of course, forfeiting a game might hurt one's leaderboard standings, but the leaderboard
      // and game engine have checks to prevent that in most cases where a game breaks early on
      //
      if (document.getElementById('arcade-game-controls-forfeit-game')) {
        document.getElementById('arcade-game-controls-forfeit-game').onclick = /*#__PURE__*/function () {
          var _ref5 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee5(e) {
            var c, _this3$invite$game_mo3;
            return _regenerator().w(function (_context5) {
              while (1) switch (_context5.n) {
                case 0:
                  _this3.overlay.remove();
                  _context5.n = 1;
                  return sconfirm('Are you sure you want to end the game and take a loss?');
                case 1:
                  c = _context5.v;
                  if (c) {
                    _this3.app.connection.emit('arcade-stop-game', (_this3$invite$game_mo3 = _this3.invite.game_mod) === null || _this3$invite$game_mo3 === void 0 ? void 0 : _this3$invite$game_mo3.name, _this3.invite.game_id, 'forfeit');
                  }
                case 2:
                  return _context5.a(2);
              }
            }, _callee5);
          }));
          return function (_x5) {
            return _ref5.apply(this, arguments);
          };
        }();
      }
      if (document.getElementById('arcade-game-controls-cancel-join')) {
        document.getElementById('arcade-game-controls-cancel-join').onclick = function (e) {
          _this3.mod.sendCancelTransaction(_this3.invite.game_id);
          _this3.overlay.remove();
        };
      }
      if (document.getElementById('arcade-game-controls-invite-join')) {
        document.getElementById('arcade-game-controls-invite-join').onclick = function (e) {
          _this3.mod.showShareLink(_this3.invite.game_id);
        };
      }

      //
      // join an in-progress open table: request a seat via the game module's
      // FOLLOW/SHARE/JOIN flow (no observer involved)
      //
      var joinTableButton = document.getElementById('arcade-game-controls-join-table');
      if (joinTableButton) {
        joinTableButton.onclick = /*#__PURE__*/function () {
          var _ref6 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee7(e) {
            var game_mod, game_tx, requestSeat;
            return _regenerator().w(function (_context7) {
              while (1) switch (_context7.n) {
                case 0:
                  game_mod = _this3.app.modules.returnModuleBySlug(_this3.invite.game_slug);
                  game_tx = _this3.mod.returnGameTransaction(_this3.invite.game_id);
                  if (!(!(game_mod !== null && game_mod !== void 0 && game_mod.opengame) || !game_tx || typeof game_mod.requestSeatAtTable !== 'function')) {
                    _context7.n = 1;
                    break;
                  }
                  console.warn('ARCADE: cannot join table -- module or game tx unavailable');
                  return _context7.a(2);
                case 1:
                  _this3.overlay.remove();
                  requestSeat = /*#__PURE__*/function () {
                    var _ref7 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee6() {
                      var r;
                      return _regenerator().w(function (_context6) {
                        while (1) switch (_context6.n) {
                          case 0:
                            _context6.n = 1;
                            return game_mod.requestSeatAtTable(game_tx);
                          case 1:
                            r = _context6.v;
                            if (!(r === 'already-playing')) {
                              _context6.n = 2;
                              break;
                            }
                            navigateWindow("/".concat(_this3.invite.game_slug), 200);
                            return _context6.a(2);
                          case 2:
                            //
                            // show the initializing-game lounge (spinner); it transitions to
                            // "Game Ready / Start Game" when all players have signed us in
                            //
                            _this3.mod.render('lounge_overlay', {
                              game_id: _this3.invite.game_id
                            });
                          case 3:
                            return _context6.a(2);
                        }
                      }, _callee6);
                    }));
                    return function requestSeat() {
                      return _ref7.apply(this, arguments);
                    };
                  }();
                  _this3.confirmStakeThen(game_mod, requestSeat);
                case 2:
                  return _context7.a(2);
              }
            }, _callee7);
          }));
          return function (_x6) {
            return _ref6.apply(this, arguments);
          };
        }();
      }
      var openSeatJoinButton = joinGameButton || joinTableButton;
      if (openSeatJoinButton) {
        var lounge = openSeatJoinButton.closest('.arcade-lounge');
        var openSeats = (lounge === null || lounge === void 0 ? void 0 : lounge.querySelectorAll('.arcade-lounge-playerbox--open')) || [];
        var _iterator3 = _createForOfIteratorHelper(openSeats),
          _step3;
        try {
          var _loop = function _loop() {
            var openSeat = _step3.value;
            var joinOpenSeat = function joinOpenSeat() {
              return openSeatJoinButton.click();
            };
            openSeat.classList.add('is-joinable');
            openSeat.setAttribute('role', 'button');
            openSeat.setAttribute('tabindex', '0');
            openSeat.setAttribute('aria-label', 'Join game in this open seat');
            openSeat.onclick = joinOpenSeat;
            openSeat.onkeydown = function (event) {
              if (event.key === 'Enter' || event.key === ' ') {
                event.preventDefault();
                joinOpenSeat();
              }
            };
          };
          for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
            _loop();
          }
        } catch (err) {
          _iterator3.e(err);
        } finally {
          _iterator3.f();
        }
      }

      //
      // viewer with a pending seat request: continue into the game room to wait
      //
      if (document.getElementById('arcade-game-controls-continue-join')) {
        document.getElementById('arcade-game-controls-continue-join').onclick = function (e) {
          _this3.overlay.remove();
          navigateWindow("/".concat(_this3.invite.game_slug), 200);
        };
      }

      //
      // ... or revoke the pending seat request (CANCEL meta, not a game cancel)
      //
      if (document.getElementById('arcade-game-controls-cancel-tentative')) {
        document.getElementById('arcade-game-controls-cancel-tentative').onclick = function (e) {
          var game_mod = _this3.app.modules.returnModuleBySlug(_this3.invite.game_slug);
          if (typeof (game_mod === null || game_mod === void 0 ? void 0 : game_mod.cancelPendingJoin) === 'function') {
            game_mod.cancelPendingJoin(_this3.invite.game_id);
          }
          _this3.overlay.remove();
        };
      }
      if (document.getElementById('arcade-game-controls-watch-game')) {
        document.getElementById('arcade-game-controls-watch-game').onclick = function (e) {
          var _this3$invite$game_id, _this3$invite;
          var gid = (_this3$invite$game_id = (_this3$invite = _this3.invite) === null || _this3$invite === void 0 ? void 0 : _this3$invite.game_id) !== null && _this3$invite$game_id !== void 0 ? _this3$invite$game_id : _this3.game_id;
          if (!gid) return;
          _this3.app.connection.emit('league-overlay-remove-request');
          _this3.mod.observeGame(gid, true, _this3.observer_game_module_slug || undefined);
          _this3.overlay.remove();
        };
      }
      if (document.getElementById('arcade-game-controls-review-game')) {
        document.getElementById('arcade-game-controls-review-game').onclick = function (e) {
          _this3.app.connection.emit('league-overlay-remove-request');
          _this3.mod.observeGame(_this3.invite.game_id);
          _this3.overlay.remove();
        };
      }
      if (document.getElementById('arcade-game-controls-clear-game')) {
        document.getElementById('arcade-game-controls-clear-game').onclick = function (e) {
          _this3.mod.removeGameFromWallet(_this3.invite.game_id);
          _this3.overlay.remove();
        };
      }

      /*Array.from(document.querySelectorAll('.available_slot')).forEach((emptySlot) => {
      emptySlot.onclick = () => {
      this.mod.showShareLink(this.invite.game_id, false);
      this.overlay.remove();
      };
      });*/

      if (document.getElementById('clear-invite')) {
        document.getElementById('clear-invite').onclick = function (e) {
          _this3.app.network.sendRequestAsTransaction('arcade clear invite', {
            game_id: _this3.invite.game_id
          }, function () {
            window.location.reload();
          });
        };
      }
    }
  }]);
}();
module.exports = LoungeOverlay;